module.exports = __webpack_public_path__ + "assets/img/_Novo Show Unit_Bathroom_RGB_lr.3d00276f.jpg";